module.exports = __webpack_public_path__ + "static/media/bg4.14d3d4fe.jpeg";